import type { MatchingSearch } from '../matching-status'
import { SupplyDataset } from '../model'

export type IncomingState = 'ready' | 'missing' | 'differences' | 'confirmed' | 'unlinked'
export interface IncomingDocument {
  can_delete?: boolean
  deleted_at?: string
  deleted_job_id?: string
  matching_search?: MatchingSearch
  basis_datasets?: string[]
  invoice_fields?: Record<string, import('../review/result-model').ReviewValue | import('../review/result-model').ReviewValue[]>
  id: string
  review_id: string
  document_number: string
  document_date: string
  supplier: string
  amount?: string
  currency?: string
  source_file?: string
  source_name: string
  queue_state: IncomingState
  line_count: number
  created_at: string
  updated_at: string
  chat_created_at: string
  reviewer_name?: string
  matches: Array<{ dataset: SupplyDataset; number: string }>
}
export const incomingStates: Record<IncomingState, { label: string; color: string }> = {
  ready: { label: 'Готов к проверке', color: 'default' },
  missing: { label: 'Не найдено соответствие', color: 'error' },
  differences: { label: 'Есть вопросы', color: 'gold' },
  confirmed: { label: 'Проверен', color: 'success' },
  unlinked: { label: 'Проверен без связи', color: 'blue' },
}
export const incomingTabs = [
  { key: 'trash', label: 'Корзина', color: '#8c8c8c' },
  { key: 'all', label: 'Все', color: '#62668b' }, { key: 'pending', label: 'Не проверены', color: '#1677ff' },
  { key: 'questions', label: 'Есть вопросы', color: '#d48806' }, { key: 'missing', label: 'Нет соответствия', color: '#cf1322' },
  { key: 'checked', label: 'Проверены', color: '#389e0d' }, { key: 'unlinked', label: 'Проверены без связи', color: '#08979c' },
]
export const incomingReviewPath = (document: IncomingDocument, listSearch: string, original = false) => {
  const query = new URLSearchParams({ document: document.id })
  if (listSearch) query.set('list', listSearch.replace(/^\?/, ''))
  return `/warehouse/reviews/${document.review_id}?${query.toString()}${original ? '#original-document' : ''}`
}
export const incomingTimestamp = (value: string) => {
  const date = new Date(value)
  return Number.isFinite(date.getTime()) ? date.toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  }) : '—'
}
